import Property from '@/domain/Property';
import Address from '@/domain/Address';
import { db, functions } from '../firebase';
import { authService } from './AuthService';
import { collection, addDoc } from "firebase/firestore";
import {httpsCallable} from "firebase/functions";

class SessionService {
  constructor() {
    this._property = new Property();
    this._property.Address = new Address();
    this._isLoading = false;
  }

  get isLoading() {
    return this._isLoading;
  }

  set isLoading(value) {
    this._isLoading = value;
  }

  get property() {
    return this._property;
  }

  set property(value) {
    this._property = value;
  }

  addCurrentPropertyToCollection() {
    this._property.UserId = authService.email;
    this._property.Email = authService.email;

    this._isLoading = true;

    let propertyDTO = this.property.toDTO();
    const getEstimates = httpsCallable(functions, 'getEstimates');
    return getEstimates(propertyDTO)
      .then(result => {
        const estimates = result.data;
        this._property.AppreciationPctAnnual = estimates.AppreciationPctAnnual;
        this._property.DownPayment = estimates.DownPayment | this._property.Price * .25;
        this._property.HoaAnnual = estimates.HoaAnnual;
        this._property.InsuranceAnnual = estimates.InsuranceAnnual;
        this._property.InterestRateAnnual = estimates.InterestRateAnnual;
        this._property.RentZestimate = estimates.RentZestimate;
        this._property.RentalAppreciationPctAnnual = estimates.RentalAppreciationPctAnnual;
        this._property.RentalPerMonth = estimates.RentalPerMonth;
        this._property.RepairCostsAnnual = estimates.RepairCostsAnnual;
        this._property.TaxesAnnual = estimates.TaxesAnnual;
        this._property.Zestimate = estimates.Zestimate;
        propertyDTO = this._property.toDTO();
        if (authService.loggerIn) {          
          return addDoc(collection(db, "properties"), propertyDTO).then(ref => {
            console.log('Added document with ID: ', ref.id);
            this._property = new Property();
            this._property.Address = new Address();
            this.isLoading = false;
            return Promise.resolve(ref.id);
          });
        } else {
          this._isLoading = false;
          console.log(propertyDTO);
          return Promise.resolve(null);
        }
      });
  }
}

export let sessionService = new SessionService();